import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {CloStepNavigation} from './stepnavigation';
import {CloStepNavigationItem} from './step-navigation-item/stepnavigationitem';

export {CloStepNavigation} from './stepnavigation';

@NgModule({
  declarations: [CloStepNavigation],
  exports: [CloStepNavigation],
  imports: [CommonModule],
  entryComponents: [CloStepNavigation]
})
export class CloStepNavigationModule { }
